import workspace from "flow/viewModels/workspace";
import MyFlow from "flow/MyFlow";

function getMyFlow(rootContext: any): MyFlow {
    if (rootContext.myFlow !== undefined) {
        // Components
        return rootContext.myFlow;
    } else if (rootContext.__myFlow !== undefined) {
        // ViewModels
        return rootContext.__myFlow;
    } else if (rootContext.getMyFlow !== undefined) {
        // Workspace
        return rootContext.getMyFlow();
    }
    return workspace.getMyFlow();
}

export default {
    getMyFlow: getMyFlow
};
